import { ObjectView } from '@/model/project/objects/object'
/*import { Line } from '@/model/project/objects/line'
import { TextView } from './objects/text';*/
import { Type } from 'class-transformer';
import { ColorUtils } from '@/model/project/utils/colorutils'
import tag from '@/model/tag'
import Konva from 'konva';
import { plainToInstance } from 'class-transformer';
import { GroupView } from './objects/group';
import { OBJECT_REGISTRY } from './utils/object-registry';
import { Script } from './script';
import { Layer } from './layer';


export class Screen {
  name: string;
  color: string;
  type: number;
  windowheight: number;
  windowwidth: number;
  usepassword: boolean;
  password: string;
  posx: number;
  posy: number;
  accesslevel: number;
  layer: Konva.Layer;
  scripts: Script[];
  timerUpdate: any
  id: number;
  data: string;
  title: string;

  @Type(() => ObjectView, {
    discriminator: {
      property: '__type',
      subTypes: [
        ...Object.entries(OBJECT_REGISTRY).map(([name, value]) => ({
          value,
          name
        })),
        { value: GroupView, name: 'group' }
      ]
    }
  })
  objects: ObjectView[];
  @Type(() => Layer)
  layers: Layer[]
  public getObjectByName(name: string): ObjectView {
    const object = this.objects.find(obj => obj.name === name);
    return object;
  }
  private initScripts(obj: ObjectView) {
    if (obj instanceof GroupView) {
      obj.objects.forEach(o => {
        this.initScripts(o)
      })
    }
    if (obj.scripts2 != null && obj.scripts2.length > 0) {
      for (let i = 0; i < obj.scripts2.length; i++) {

        obj.scripts2[i] = plainToInstance(Script, JSON.parse(JSON.stringify(obj.scripts2[i])));
      }
    }
  }
  public checkObjects(): void {
    console.log("checkObjects", this.objects);
    if (this.objects == null) return;
    this.objects.forEach(obj => {
      if (obj.isUpdate()) {
        obj.drawObject();
        obj.checkQualityObjectTags();
      }
    })
  }
  public drawObjects(stage: Konva.Stage): void {
    if (this.scripts != null && this.scripts.length != 0) {
      for (let i = 0; i < this.scripts.length; i++) {
        this.scripts[i] = plainToInstance(Script, JSON.parse(JSON.stringify(this.scripts[i])));
        if (this.scripts[i] != null && this.scripts[i].extype < 2)
          this.scripts[i].runSTScript(this, null);
      }
    }
    stage.removeChildren();
    this.layer = new Konva.Layer();
    stage.add(this.layer);
    const background = new Konva.Rect({
      x: 0,
      y: 0,
      width: this.windowwidth,
      height: this.windowheight,
      fill: ColorUtils.convertformat(this.color),
      listening: false,
    });
    this.layer.add(background);
    if (this.layers != undefined && this.layers != null) {
      this.layers.forEach((l => {
        this.objects = [...this.objects, ...l.objects];
      }))
    }
    //console.log("this.objects="+this.objects)
    this.objects.forEach((obj => {
      obj.screen = this.name
      obj.name = obj.name.replace("{screen}", this.name)
      obj.name = obj.name.replace("{screendata}", this.data)
      this.initScripts(obj)
      obj.initLayer(this.layer);
      obj.executeOnCreateScripts(this);
      obj.drawObject();
      obj.checkQualityObjectTags();
      obj.CheckFunctions(this, obj);
    }))

    if (this.timerUpdate != null)
      clearInterval(this.timerUpdate);
    this.timerUpdate = setInterval(() => {
      if (this.objects == null) return;
      this.objects.forEach(obj => {
        if (obj.isUpdate()) {
          obj.setUpdate(false)
          obj.drawObject();
          obj.checkQualityObjectTags();
        }
      })
    }, 1000);

  }
  public deleteObjects(): void {
    if (this.timerUpdate != null)
      clearTimeout(this.timerUpdate);
    console.log("deleteObjects")
    if (this.scripts != null) {
      this.scripts.forEach((scr => {
        if (scr != null && scr.extype == 2)
          scr.runSTScript(this, null);
      }))
    }
    if (this.objects != null) {
      this.objects.forEach((obj => {
        obj.executeOnDestroyScripts(this)
        obj.deleteObject();

      }))
    }

    ///this.scripts.splice(0, this.scripts.length)
    this.layer = null;
  }
  public updateObjects(tag: tag): void {

    if (this.scripts != null && this.scripts.length != 0) {
      this.scripts.forEach((scr => {

        if (scr != null && scr.tagnames != null && scr.tagnames.includes(tag.path) && scr.extype == 0)
          scr.runSTScript(this, null);
      }))
    }
    if (this.objects != null && this.objects.length != 0) {
      this.objects.forEach((obj => {
        obj.executeOnDataChangeScripts(this, tag)
        //   console.log(obj.name+" "+obj.tagnames)
        if (obj.tagnames != null && obj.tagnames.includes(tag.path)) {
          obj.setUpdate(true)
          console.log("update Object:", obj)
        }
      }))
    }
  }
}